export const MOCKED_CHART_POINTS = 100;
